module.exports = __webpack_public_path__ + "img/pause.c5bf04aa.png";